import { ReactElement } from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { createServerSideHelpers } from '@trpc/react-query/server';
import styled, { css } from 'styled-components';

import MainLayout from 'components/layout/mainLayout';
import WalletLayout from 'components/layout/walletLayout';
import MaxWidthWrapper from 'components/layout/maxWidthWrapper';

import { createContext } from 'server/context';
import superJson from 'utils/superJson';
import { appRouter } from 'server/routers/_app';

import useLayout from 'providers/layout/layoutProvider';
import theme, { bp, color } from 'settings/theme';

type Props = {};

const GobiPage: NextPageExtended<Props> = (props) => {

  const layout = useLayout();

  return (
    <>
      <Head>
        <title>$Gobi Token : Gobi Labs</title>
        <meta name="description" content="Gobi Token" />
      </Head>
      <StyledGobiPage className="gobiPage">

        <MaxWidthWrapper className="gobiPage-pageWrapper gobiPage-usesSection">
          
          <h2>What You Can Use $GOBI For</h2>

          <div className="gobiPage-uses">

            {/* Oasis  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--oasis" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-oasis.png)'}}>
              <div className="gobiPage-uses-item-main">
                Earn $GOBI <em>emissions</em> from staking & providing liquidity on the Oasis
              </div>
              <div className="gobiPage-uses-item-bottom">
                <Link href="https://marcopolo.so">Add Liquidity</Link>
              </div>
            </div>
          
            {/* Merchants  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--merchants" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-merchants.png)'}}>
              <div className="gobiPage-uses-item-main">
                <em>Redeem</em> $SOL every month by burning <em>Medallions</em> & <em>$GOBI</em>
              </div>
            </div>

            {/* Ormuz & HighJinx  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--ormuz" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-ormuz.png)'}}>
              <div className="gobiPage-uses-item-main">
                Buy <em>exclusive</em> items from <em>HighJinx</em> & <em>Ormuz</em> only available with $GOBI
              </div>
            </div>

            {/* Colosseum  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--colosseum" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-colosseum.png)'}}>
              <div className="gobiPage-uses-item-top">
                (ETA 2023 Q4)
              </div>
              <div className="gobiPage-uses-item-main">
                Receive <em>JACKPOT</em> tickets every time you bet in $GOBI on the <em>Colosseum</em>
              </div>
              <div className="gobiPage-uses-item-bottom">
                <Link href="https://colloseum.so">Bet</Link>
              </div>
            </div>

            {/* Eden  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--eden" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-eden.png)'}}>
              <div className="gobiPage-uses-item-top">
                (ETA 2023 Q4)
              </div>
              <div className="gobiPage-uses-item-main">
                Receive a 20% discount every time you buy cannabis in <em>$GOBI</em> in <em>Thailand</em>
              </div>
            </div>

            {/* Blank  */}
            <div className="gobiPage-uses-item gobiPage-uses-item--blank" style={{backgroundImage: 'url(/images/gobi-uses/gobi-uses-blank.png)'}}></div>

          </div>

        </MaxWidthWrapper>

        <MaxWidthWrapper className="gobiPage-pageWrapper gobiPage-diagramSection">
          
          <h2>The $GOBI Ecosystem Token</h2>

          <div className="gobiPage-diagram">

            <div className="gobiPage-diagram-bars">
              <div className="gobiPage-diagram-bar" style={{height: '20%', backgroundColor: color.gray(30)}} />
              <div className="gobiPage-diagram-bar" style={{height: '35%', backgroundColor: color.gray(75)}} />
              <div className="gobiPage-diagram-bar" style={{height: '1.5%', backgroundColor: color.gray(100)}} />
              <div className="gobiPage-diagram-bar" style={{height: '15%', backgroundColor: color.gray(20)}} />
              <div className="gobiPage-diagram-bar" style={{height: '4%', backgroundColor: color.gray(50)}} />
              <div className="gobiPage-diagram-bar" style={{height: '25.5%', backgroundColor: color.gray(40)}} />
            </div>

            <div className="gobiPage-diagram-legend">
              
              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(30)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>Treasury</span>
                  <span>20,000,000 (20%)</span>
                </div>
              </div>

              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(75)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>Staking Emissions</span>
                  <span>35,000,000 (35%)</span>
                </div>
              </div>

              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(100)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>MAPS NFT Holder Airdrop</span>
                  <span>1,500,000 (1.5%)</span>
                </div>
              </div>

              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(20)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>Team</span>
                  <span>15,000,000 (15%)</span>
                </div>
              </div>

              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(50)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>Angel Round Investors</span>
                  <span>4,000,000 (4%)</span>
                </div>
              </div>

              <div className="gobiPage-diagram-row">
                <div className="gobiPage-diagram-row-box" style={{backgroundColor: color.gray(40)}}></div>
                <div className="gobiPage-diagram-row-text">
                  <span>DEX Emissions</span>
                  <span>24,500,000 (24.5%)</span>
                </div>
              </div>

            </div>

          </div>

        </MaxWidthWrapper>

        

      </StyledGobiPage>
    </>
  );

}


export const getStaticProps = async ({ params }) => {

  const ssh = createServerSideHelpers({
    router: appRouter,
    ctx: await createContext(),
    transformer: superJson
  });

  return {
    props: {
      trpcState: ssh.dehydrate(),
    },
    revalidate: 1
  };

};


GobiPage.getLayout = (page: ReactElement) => {
  return (
    <MainLayout>
      <WalletLayout>
        {page}
      </WalletLayout>
    </MainLayout>
  )
}


export default GobiPage;

const StyledGobiPage = styled.div`

  display: block;
  padding-top: 2rem;
  padding-bottom: 6rem;

  h2{
    margin-bottom: 2rem;
  }

  .gobiPage-pageWrapper{
    padding: 0 1rem;
    max-width: 75rem;
  }

  .gobiPage-usesSection{

  }

  .gobiPage-uses{

    display: grid;
    grid-template-columns: 1fr;
    border: 1px solid ${color.gray(40)};
    border-radius: 0.75rem;

    .gobiPage-uses-item{
      
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      aspect-ratio: 1/1;
      border-bottom: 1px solid ${color.gray(40)};
      background-size: cover;

      &:last-of-type{
        border-bottom: none;
      }

      .gobiPage-uses-item-top{
        position: absolute;
        top: 1rem;
        left: 50%;
        transform: translateX(-50%);
        color: ${color.gray(50)};
        font-size: 0.875rem;
      }

      .gobiPage-uses-item-main{

        max-width: 66.6%;
        font-size: 1.4rem;
        font-weight: 600;
        text-align: center;

        em{
          font-style: normal;
          font-weight: 750;
        }

      }

      .gobiPage-uses-item-bottom{

        position: absolute;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%);

        button, a{

          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-width: 8rem;
          height: 2.5rem;
          padding: 0 3rem;
          color: black;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 0.25rem;
          white-space: nowrap;
          background-color: ${color.gray(80)};
          transition: all 0.2s ease-in-out;

          &:hover{
            background-color: ${color.gray(100)};
          }

          img{
            width: 0.6rem;
            height: 0.6rem;
            margin-left: 0.5rem;
          }

        }

      }

      .gobiPage-uses-item-bottom{
        position: absolute;
      }

      &.gobiPage-uses-item--oasis em{
        color: ${color.oasisBlue(60)}
      }

      &.gobiPage-uses-item--merchants em{
        color: ${color.merchantsYellow(60)}
      }

      &.gobiPage-uses-item--ormuz em{
        color: ${color.ormuzGreen(60)}
      }

      &.gobiPage-uses-item--colosseum em{
        color: ${color.colosseumPurple(60)}
      }

      &.gobiPage-uses-item--eden em{
        color: ${color.edenGreen(80)}
      }

    }

  }

  .gobiPage-diagramSection{
    margin-top: 3rem;
  }

  .gobiPage-diagram{

    display: flex;
    gap: 2rem;
    width: 100%;
    min-height: 20rem;

    .gobiPage-diagram-bars{
      flex: 1 1 auto;
      min-width: 25%;
    }

    .gobiPage-diagram-legend{
      align-self: center;
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }

    .gobiPage-diagram-row{

      display: flex;
      gap: 0.5rem;

      .gobiPage-diagram-row-box{
        flex: 0 0 auto;
        width: 1rem;
      }

      .gobiPage-diagram-row-text{
        flex: 1 1 auto;

        span{

          display: block;

          &:first-of-type{
            font-size: 0.75rem;
            opacity: 0.75;
          }

          &:last-of-type{
            margin-top: 0.25rem;
            font-weight: 700;
          }

        }
      }

    }

  }


  @media (min-width: 40rem) {

    .gobiPage-uses{

      grid-template-columns: 1fr 1fr;

      .gobiPage-uses-item{

        border-right: 1px solid ${color.gray(40)};

        &:nth-child(2n){
          border-right: none;
        }

        &:nth-last-child(-n+2){
          border-bottom: none;
        }

      }

    }

  }

  @media (min-width: ${bp(4)}) {

    padding-top: 4rem;

    .gobiPage-pageWrapper{
      padding: 0 1.5rem;
    }

    .gobiPage-uses{

      grid-template-columns: 1fr 1fr 1fr;

      .gobiPage-uses-item{

        &:nth-child(2n){
          border-right: 1px solid ${color.gray(40)};
        }

        &:nth-child(3n){
          border-right: none;
        }

        &:nth-last-child(-n+3){
          border-bottom: none;
        }

      }

    }

    .gobiPage-diagramSection{
      margin-top: 6rem;
    }

    .gobiPage-diagram{

      gap: 8rem;
      min-height: 30rem;

      .gobiPage-diagram-bars{
        min-width: 60%;
      }

      .gobiPage-diagram-legend{
        gap: 0.75rem;
      }

      .gobiPage-diagram-row{

        gap: 1rem;

        .gobiPage-diagram-row-box{
          width: 1.5rem;
        }

        .gobiPage-diagram-row-text{

          flex: 1 1 auto;

          span{

            &:first-of-type{
              font-size: 0.875rem;;
            }

            &:last-of-type{
              margin-top: 0.5rem;
            }

          }
        }

      }

    }

  }

  @media (min-width: ${bp(5)}) {

    .gobiPage-pageWrapper{
      padding: 0 2rem;
    }

  }


`;
